import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CalendarDays } from "lucide-react";

export default function FloatingConsultationCta() {
  const location = useLocation();
  const [nearFooter, setNearFooter] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const doc = document.documentElement;
      const scrolledBottom = window.innerHeight + window.scrollY;
      const total = doc.scrollHeight;
      setNearFooter(total - scrolledBottom < 240);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, [location.pathname]);

  return (
    <>
      {/* Mobile: full-width sticky bar */}
      <div
        data-testid="floating-cta-mobile"
        aria-hidden={nearFooter ? "true" : "false"}
        className={`md:hidden fixed inset-x-0 bottom-0 z-40 border-t transition-opacity duration-200 ${
          nearFooter ? "opacity-0 pointer-events-none" : "opacity-100"
        }`}
        style={{
          backgroundColor: "rgba(250, 247, 240, 0.96)",
          backdropFilter: "blur(8px)",
          borderColor: "var(--wt-border)",
          boxShadow: "0 -10px 24px rgba(2,44,34,0.08)",
          paddingBottom: "calc(env(safe-area-inset-bottom) + 10px)",
        }}
      >
        <div className="wt-container py-3">
          <Link
            to="/book-consultation"
            data-testid="floating-cta-mobile-button"
            className="wt-btn-primary w-full h-12 text-base"
          >
            <CalendarDays size={16} aria-hidden="true" /> Book a Consultation
          </Link>
        </div>
      </div>

      {/* Desktop: pill in the bottom-right */}
      <div
        data-testid="floating-cta-desktop"
        aria-hidden={nearFooter ? "true" : "false"}
        className={`hidden md:block fixed z-40 transition-all duration-200 ${
          nearFooter ? "opacity-0 pointer-events-none translate-y-2" : "opacity-100"
        }`}
        style={{ right: "32px", bottom: "32px" }}
      >
        <Link
          to="/book-consultation"
          data-testid="floating-cta-desktop-button"
          className="wt-btn-primary h-12 px-5 text-sm shadow-[0_14px_30px_rgba(2,44,34,0.25)]"
          style={{
            boxShadow:
              "0 16px 32px rgba(2,44,34,0.28), inset 0 0 0 1px rgba(201,162,39,0.45)",
          }}
        >
          <CalendarDays size={16} aria-hidden="true" /> Book a Consultation
        </Link>
      </div>
    </>
  );
}
